export const ZspArt = {
	Saldo: 'S',
	Bereich: 'B',
};